import React from 'react'
import { SelectProps, Space, Typography } from 'antd'
import { LockFilled } from '@ant-design/icons'
import dayjs from 'dayjs'

export const disabledLockRender: SelectProps['optionRender'] = ({ label, data: { isLocked, forecastCursor } }) => {
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8 }}>
      <Space style={{ minWidth: 0, overflow: 'hidden' }}>
        {isLocked ? <LockFilled style={{ flexShrink: 0 }} /> : null}
        <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{label}</span>
      </Space>
      {forecastCursor && (
        <Typography.Text type="secondary" style={{ fontSize: 12, flexShrink: 0 }}>
          {dayjs(forecastCursor).format('MM/YYYY')}
        </Typography.Text>
      )}
    </div>
  )
}
